
    const url = require("url");
    const renderer = require("/Users/masachika/src/github.com/oprstchn/react-chart-editor/node_modules/@percy/react-percy-snapshot-render/lib/index.js");

    const render = renderer.default || renderer;

    const rootSuite = window["__PERCY_ROOT_SUITE__"];

    const parsedUrl = url.parse(window.location.href, true);
    const snapshotName = parsedUrl.query.snapshot;

    const rootEl = document.getElementById("percy-root");

    rootSuite.getSnapshotMarkup(snapshotName)
      .then(function(markup) {
        return render(markup, rootEl);
      });
  


// WEBPACK FOOTER //
// /private/var/folders/l6/tzd831c53fj82q59w2p7q27m0000gn/T/tmp-39634z0pVaVuOgWO.js